import { css } from '@emotion/react';

import { campaignManagerTheme } from '@campaign-manager/theme';

export type Color = keyof typeof campaignManagerTheme.color;

export const badge = css`
  padding: 4px 14px;
  border-radius: 11px;
  width: max-content;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const badgeCircular = css`
  border-radius: 50%;
  padding: 6px;
  width: 20px;
  height: 20px;
`;

export const color = (color: Color) => css`
  background-color: ${campaignManagerTheme.color[color]};
`;
